import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { formatMoney } from "../employee/shop/EnrollmentDataUtil";
import useAccount from "./hooks/useAccount";
import { decodeHtmlContent } from "../../utils";

const Wallet = ({ intl, account }) => {
  const { entitled, totalSpend, available } = useAccount(account);
  const utilized = Math.abs(totalSpend);
  const availablePoints = Number(available);
  const overPurchasePoints = utilized > entitled ? utilized - entitled : 0;
  const completedPercentage =
    utilized <= entitled ? (utilized / entitled) * 100 : (overPurchasePoints / utilized) * 100;
  const salaryDeductionFlag = account.transactions.some(
    item => item.transactionTypeId === "SalaryDeduction"
  );
  return (
    <div className="wallet-container" style={{ padding: "0", maxWidth: "800px" }}>
      <span className="wallet-label">
        {intl.formatMessage(messages.accountOwnerDescription)}: <strong>{decodeHtmlContent(account.owner)}</strong>
      </span>
      <div>
        {entitled == "999999999999" ? (
          <div className="wallet-available">
            <span>
              {intl.formatMessage(messages.enrollment.availableBalanceDescription)}:
              <strong> {intl.formatMessage(messages.unlimitedDescription)}</strong>
            </span>
          </div>
        ) : (
          <div className="wallet-available">
            <span>{intl.formatMessage(messages.enrollment.availableBalanceDescription)} </span>
            <strong>
              <strong>{formatMoney(availablePoints < 0 ? 0 : availablePoints)}</strong>
            </strong>
            <span>{intl.formatMessage(messages.ofDescription)} </span>
            <strong>
              <strong>{formatMoney(entitled)}</strong>
            </strong>
          </div>
        )}
        <div
          className={
            overPurchasePoints <= 0 ? "wallet-bar-container" : "wallet-over-purchased-bar-container"
          }
        >
          <div
            className={overPurchasePoints <= 0 ? "wallet-filler" : "wallet-over-purchased"}
            style={{
              width: `${
                completedPercentage > 0 && completedPercentage < 2 ? 2 : completedPercentage
              }%`,
            }}
          ></div>
        </div>
        <div className="utilization-container" style={{ marginBottom: "10px" }}>
          <span>{intl.formatMessage(messages.otherBenefits.usedBalance)} </span>
          <span className="used-balance">
            <strong>
              <strong>{formatMoney(utilized > entitled ? entitled : utilized)}</strong>
            </strong>
          </span>
          {!salaryDeductionFlag && overPurchasePoints > 0 && (
            <span>
              <span> + {intl.formatMessage(messages.enrollment.overPurchasedDescription)}: </span>
              <span className="over-purchased-balance">
                <strong>
                  <strong>{formatMoney(overPurchasePoints)}</strong>
                </strong>
              </span>
            </span>
          )}
        </div>
        {intl.formatMessage(messages.soaCurrencyDescription)} <strong>{account.currency}</strong>
      </div>
    </div>
  );
};

Wallet.propTypes = {
  intl: PropTypes.shape(intlShape).isRequired,
  isNarrowScreen: PropTypes.bool,
  utilized: PropTypes.number,
  entitled: PropTypes.number,
  account: PropTypes.object,
};

export default injectIntl(Wallet);



// WEBPACK FOOTER //
// ./components/claim/Wallet.jsx